import React, { useRef, useState } from "react";
import { TextField, Button, Grid, Select, MenuItem, Typography, InputLabel, Checkbox } from '@mui/material';
import swal from 'sweetalert';
import { DatosProveedoresInternacional, ingresoDOCXWorkmanagerFlujo } from '../FunctionLogin.js'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Alert
} from '@mui/material';
import SignatureCanvas from "react-signature-canvas";
import { Directions } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';
import { generarPDF } from './personaInternacionalPDF.js'

export default function PersonaInternacional({ solicitanteValue, procesoValue, sucursalValue, servicioValue, tipoNegociacionValue, tipoNegociacion2Value, idregisto, nombreFormato, cargoFormato, tipoPersonaRegistro, tipoVinculacionRegistro }) {
    const sigPad = useRef({});
    const [tableData, setTableData] = useState([{ tipoProducto: '', nombreProducto: '', entidad: '', monto: '', ciudad: '', pais: '', moneda: '' }]);
    const [tableDataParticipacion, setTableDataParticipacion] = useState([{ identificacion: '', nombre: '', Participacion: '' }]);

    const navigate = useNavigate();

    const handleCopyRow = () => {
        setTableData((prevTableData) => {
            const lastRow = prevTableData[prevTableData.length - 1];
            const newRow = { ...lastRow };
            Object.keys(newRow).forEach((key) => {
                newRow[key] = '';
            });
            return [...prevTableData, newRow];
        });
    };

    const handleCopyRowParticiapacion = () => {
        setTableDataParticipacion((prevTableDatav2) => {
            const lastRowv2 = prevTableDatav2[prevTableDatav2.length - 1];
            const newRowv2 = { ...lastRowv2 };
            Object.keys(newRowv2).forEach((key) => {
                newRowv2[key] = '';
            });
            return [...prevTableDatav2, newRowv2];
        });
    };



    const handleCellChange = (event, rowIndex, fieldName) => {
        const updatedTableData = [...tableData];
        updatedTableData[rowIndex][fieldName] = event.target.value;
        setTableData(updatedTableData);
    };

    const handleCellChangeParticipacion = (event, rowIndex, fieldName) => {
        const updatedTableDatav2 = [...tableDataParticipacion];
        updatedTableDatav2[rowIndex][fieldName] = event.target.value;
        setTableDataParticipacion(updatedTableDatav2);
    };





    const [firmaFile, setFirmaFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rutFile, setRutFile] = useState(null);
    const [camaraComercioFile, setCamaraComercioFile] = useState(null);
    const [ccIdRepresentanteFile, setCcIdRepresentanteFile] = useState(null);
    const [polizaSeguroFile, setPolizaSeguroFile] = useState(null);
    const [polizaSeguroFile2, setPolizaSeguroFile2] = useState(null);
    const [certificadosCinco, setCertificadosCincoFile] = useState(null);
    const [certificadoActuales, setCertificadoActualesFile] = useState(null);
    const [referenciasPersonalesFile, setReferenciasPersonalesFile] = useState(null);




    const [estadosFinancierosFile, setEstadosFinancierosFile] = useState(null);
    const [certificacionBancariaFile, setCertificacionBancariaFile] = useState(null);
    const [nombres, setNombres] = useState('');
    const [nit, setNit] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [tipoIdentificacion, setTipoIdentificacion] = useState('Pasaporte');
    const tipoIdentificacionValues = [
        "ID",
        "Pasaporte",
    ];

    const [numeroIdentificacion, setNumeroIdentificacion] = useState('');
    const [expedidaEn, setExpedidaEn] = useState('');
    const [direccion, setDireccion] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [codigoCIIU, setCodigoCIIU] = useState('');
    const [email, setEmail] = useState('');
    const [pais, setPais] = useState('');
    const [ocupacionProfesion, setOcupacionProfesion] = useState('');
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [cargo, setCargo] = useState('');
    const [tipoEmpresa, setTipoEmpresa] = useState('');
    const tipoEmpresaValues = [
        "Publica",
        "Privada",
        "Mixta",
    ];

    const [categoria, setCategoria] = useState('');
    const [tipoProducto, setTipoProducto] = useState('');

    const [tipoTransaccion, setTipoTransaccion] = useState('');
    const tipoTransaccionValue = [
        "Ninguna",
        "Importación",
        "Exportación",
        "Inversiones",
        "Préstamos",
        "Transferencias",
        "Otros",
    ];

    let date = new Date();
    const [fechainicial, setfechainicial] = React.useState(dayjs(date.toISOString().split('T')[0]));

    const [fechainicialCompania, setfechainicialCompania] = React.useState(dayjs(date.toISOString().split('T')[0]));



    const [direccionEmpresa, setDireccionEmpresa] = useState('');
    const [paisCiudad, setPaisCiudad] = useState('');



    const [direccionOficina, setDireccionOficina] = useState('');
    const [paisOficina, setPaisOficina] = useState('');
    const [ciudadOficina, setCiudadOficina] = useState('');
    const [telefonoOficina, setTelefonoOficina] = useState('');
    const [correoOficina, setCorreoOficina] = useState('');

    const [direccionSucursal, setDireccionSucursal] = useState('');
    const [paisSucursal, setPaisSucursal] = useState('');
    const [ciudadSucursal, setCiudadSucursal] = useState('');
    const [telefonoSucursal, setTelefonoSucursal] = useState('');
    const [correoSucursal, setCorreoSucursal] = useState('');


    const [telefonoEmpresa, setTelefonoEmpresa] = useState('');
    const [emailEmpresa, setEmailEmpresa] = useState('');
    const [otroCertificado, setOtroCertificado] = useState('');
    const [certificadoNinguno, setCertificadoNinguno] = useState(false);

    const [otroLavadoDeActivos, setOtroLavadoDeActivos] = useState('');

    const [servicioMujereMinoria, setServicioMujereMinoria] = useState("");
    const [equitativasYAmbientales, setEquitativasYAmbientales] = useState("");
    const [huellaDeCarbono, setHuellaDeCarbono] = useState("");
    const [reducionImpactoAmbiente, setReducionImpactoAmbiente] = useState("");
    const [certificadoDeGestion, setCertificadoDeGestion] = useState("");




    const [nombreComercial, setNombreComercial] = useState('');
    const [nombreContabilidad, SetNombreContabilidad] = useState('');
    const [nombreTesoreria, setNombreTesoreria] = useState('');
    const [nombreComercialCorreo, setNombreComercialCorreo] = useState('');
    const [nombreContabilidadCorreo, SetNombreContabilidadCorreo] = useState('');
    const [nombreTesoreriaCorreo, setNombreTesoreriaCorreo] = useState('');


    const [terrorismo, setTerrorismo] = useState(false);
    const [eticaEmpresarial, setEticaEmpresarial] = useState(false);

    const [certificadoBasc, setCertificadoBasc] = useState(false);
    const [certificadoIso, setCertificadoIso] = useState(false);
    const [certificadoOea, setCertificadoOea] = useState(false);

    const [funcionarioPublico, setFuncionarioPublico] = useState(false);
    const [administraRecursosPublicos, setAdministraRecursosPublicos] = useState(false);
    const [reconocimientoPublico, setReconocimientoPublico] = useState(false);

    const [granContribuyenteCheck, setGranContribuyenteCheck] = useState(false);
    const [granContribuyenteResolucion, setGranContribuyenteResolucion] = useState("");
    const [fechainicialGranContribuyente, setFechainicialGranContribuyente] = React.useState(dayjs(date.toISOString().split('T')[0]));
    const [opcionSeleccionada, setOpcionSeleccionada] = useState('');


    const [fechaRenta, setFechaRenta] = React.useState(dayjs(date.toISOString().split('T')[0]));
    const [responsableRentaCheck, setResponsableRentaCheck] = useState(false);
    const [rentaCheck, setRentaCheck] = useState(false);
    const [regimenCheck, setReegimenCheck] = useState(false);
    const [rentaResolucion, setRentaResolucion] = useState("");

    const [ciudadIca, setCiudadIca] = useState("");
    const [tarifaPorMil, setTarifaPorMil] = useState("");
    const [autoRetenedorCheckIca, setAutoRetenedorCheckIca] = useState(false);
    const [icaResolucion, setIcaResolucion] = useState("");
    const [fechaIca, setFechaIca] = React.useState(dayjs(date.toISOString().split('T')[0]));
    const [totalActivos, setTotalActivos] = useState("");
    const [totalPasivos, setTotalPasivos] = useState("");
    const [patrimonio, setPatrimonio] = useState("");
    const [checkRealizaTransaccionesMonedaExtra, setCheckRealizaTransaccionesMonedaExtra] = useState(false);
    const [otroTipo, setOtroTipo] = useState("");
    const [Detalle, setDetalle] = useState("");
    const [nombreSolicitante, setNombreSolicitante] = useState("");
    const [Firma, setFirma] = useState("");
    const [documentoFirma, setDocumentoFirma] = useState("");
    const [EmpleadoTalsa, setEmpleadoTalsa] = useState("");




    const handleRutChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setRutFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }

    };

    const handleOpcionSeleccionadaChange = (event) => {
        setOpcionSeleccionada(event.target.value);
    };

    const handleCamaraComercioChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCamaraComercioFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };

    const handleCcIdRepresentanteChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCcIdRepresentanteFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };

    const handlePolizaSeguroChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setPolizaSeguroFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };
    const handlePolizaSeguroChange2 = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setPolizaSeguroFile2(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };
    const handleReferenciasPersonalesChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setReferenciasPersonalesFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };



    const handleCertificadosCincoChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCertificadosCincoFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };


    const handleCertificadoActualesChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCertificadoActualesFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };

    const handleEstadosFinancierosChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setEstadosFinancierosFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };

    const handleCertificacionBancariaChange = (event) => {
        const file = event.target.files[0];
        if (file.type === "application/pdf") {
            const selectedFile = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                setCertificacionBancariaFile(reader.result);
            };

        } else {
            event.target.value = null;
            swal("Please validate the information, as only PDF is accepted!", "Validate the information!", "warning");
        }
    };


    const [currentDate, setCurrentDate] = useState(new Date());

    React.useEffect(() => {
        setCurrentDate(new Date());
    }, []);

    const handleSubmit = async (event) => {
        setLoading(true)
        event.preventDefault();
        if (firmaFile == null) {
            swal("Error", "You must sign the document!", "warning");
            setLoading(false)
            return
        }
        const data = {
            FIRSTNAME: nombres,
            LASTNAME: apellidos,
            PASAPORTEtype: tipoIdentificacion,
            PASAPORTENUMBER: numeroIdentificacion,
            ISSUEDIN: expedidaEn,
            EXPEDITIONDATE: new Date(fechainicial).toISOString().split('T')[0],
            ADDRESS: direccion,
            CITY: ciudad,
            PHONE: telefono,
            CELLPHONE: celular,
            COUNTRY: pais,
            EMAIL: email,
            RAZONSOCIAL: nombreEmpresa,
            NIT: nit,
            DIRECCIoNOFICINAPRINCIPAL: direccionOficina,
            PAIS: paisOficina,
            CIUDAD: ciudadOficina,
            TELEFONOOFICINAPRINCIPAL: telefonoOficina,
            CORREOOFICINAPRINCIPAL: correoOficina,
            DIRECCIoNSUCURSALOAGENCIA: direccionSucursal,
            PAISSUCURSAL: paisSucursal,
            CIUDADSUCURSAL: ciudadSucursal,
            TELEFONOSUCURSAL: telefonoSucursal,
            CORREOSUCURSAL: correoSucursal,
            FECHACONSTITUCIoNDELACOMPANIA: new Date(fechainicialCompania).toISOString().split('T')[0],
            BASC: certificadoBasc,
            ISO28001: certificadoIso,
            OEA: certificadoOea,
            OTROCERTIFICADO: otroCertificado,
            NINGUNO: certificadoNinguno,
            LAVADODEACTIVOS: otroLavadoDeActivos,
            LAVADODEACTIVOSNOAPLICA: terrorismo,
            ETICAEMPRESARIAL: eticaEmpresarial,
            Sociosoaccionistas: JSON.stringify(tableDataParticipacion),
            FUNCIONARIOPUBLICO: funcionarioPublico,
            ADMINISTRARECURSOSPUBLICOS: administraRecursosPublicos,
            RECONOCIMIENTOPUBLICO: reconocimientoPublico,
            TRANSACCIONESMONEDAEXTRANJERA: checkRealizaTransaccionesMonedaExtra,
            ACTIVIDADENOPERACIONES: tipoTransaccion,
            PRODUCTOS: JSON.stringify(tableData),
            FIRMA: Firma,
            NOMBRESOLICITANTE: nombreSolicitante,
            DOCUMENTO: documentoFirma,
            EMPLEADOTALSA: EmpleadoTalsa,
            DETALLE: Detalle,
            servicioMujereMinoria: servicioMujereMinoria,
            equitativasYAmbientales: equitativasYAmbientales,
            huellaDeCarbono: huellaDeCarbono,
            reducionImpactoAmbiente: reducionImpactoAmbiente,
            certificadoDeGestion: certificadoDeGestion,
            TIPO_VINCULACION: tipoVinculacionRegistro
        };



        const files = [
            { base64: rutFile, tipo: "RutProveedor", ext: ".pdf" },
            { base64: camaraComercioFile, tipo: "camaraComercioFile", ext: ".pdf" },
            { base64: certificacionBancariaFile, tipo: "CertificadoBancario", ext: ".pdf" },
            { base64: ccIdRepresentanteFile, tipo: "FotocopiadeCC", ext: ".pdf" },
            { base64: polizaSeguroFile, tipo: "PolizaSeguros", ext: ".pdf" },
            { base64: polizaSeguroFile2, tipo: "PolizaSeguros", ext: ".pdf" },
            { base64: firmaFile, tipo: "Firma", ext: ".png" },
            /* { base64: `data:application/pdf;base64,${await generarPDF(data, firmaFile)}`, tipo: "archivoproveedor", ext: ".pdf" }*/

        ];


        const jsonData = JSON.stringify(data);
        const productos = JSON.stringify(tableData)
        const datosv2 = JSON.stringify(tableDataParticipacion)


        console.log(datosv2)
        var raw = JSON.stringify({
            "datos": `${jsonData}`,
            "firma": `${firmaFile}`,
            "productos": `${productos}`,
            "participacion": `${datosv2}`
        });
        //console.log(firmaFile)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        //fetch("https://consumos.talsa.com.co/api/talsa/pdf/v1/pdfproveedorinternacional", requestOptions)
        fetch("https://consumos.talsa.com.co/api/talsa/pdf/v1/pdfproveedorinternacional", requestOptions)
            .then(response => {
                if (response.status == 200) {
                    return response.text(); // Return the response text to the next then
                } else {
                    setLoading(false)
                    swal("Error", "The document was not created successfully", "error");
                    throw new Error('The document was not created successfully');
                }
            })
            .then(responseText => {
                const responseJson = JSON.parse(responseText);
                const base64 = responseJson.base64;
                console.log(base64)
                DatosProveedoresInternacional(files, data).then((result) => {
                    ingresoDOCXWorkmanagerFlujo(base64, result, "archivoproveedor").then(() => {
                        swal("Successful", "The document was created successfully", "success");
                        setLoading(false)
                        navigate('/proveedores/cerrar');
                    });
                })
            })
    };

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="p">Legal Representative or CEO</Typography>
                </Grid>

                {/* Additional Fields */}
                <Grid item xs={6} sm={2}>
                    <InputLabel>First Name</InputLabel>
                    <TextField
                        required
                        fullWidth
                        value={nombres}
                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        onChange={(e) => setNombres(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <InputLabel>Last Name</InputLabel>
                    <TextField
                        required
                        fullWidth
                        value={apellidos}

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        onChange={(e) => setApellidos(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6} sm={1}>
                    <InputLabel htmlFor="tipo-identificacion">Type</InputLabel>
                    <Select
                        required
                        fullWidth
                        label="Identification Type"
                        value={tipoIdentificacion}

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        onChange={(e) => setTipoIdentificacion(e.target.value)}
                    >
                        {tipoIdentificacionValues.map((tipo) => (
                            <MenuItem key={tipo} value={tipo}>
                                {tipo}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={6} sm={2}>
                    <InputLabel>Number</InputLabel>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={numeroIdentificacion}
                        onChange={(e) => setNumeroIdentificacion(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <InputLabel>Issued in</InputLabel>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={expedidaEn}
                        onChange={(e) => setExpedidaEn(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6} sm={2} style={{ padding: 8 }}>
                    <InputLabel>Expedition Date</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DatePicker
                                value={fechainicial}
                                onChange={(newValue) => { setfechainicial(newValue); }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={5}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Address"
                        value={direccion}
                        onChange={(e) => setDireccion(e.target.value)}
                    />
                </Grid>
                <Grid item xs={3} sm={3}>
                    <TextField
                        required
                        fullWidth
                        label="City"

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={ciudad}
                        onChange={(e) => setCiudad(e.target.value)}
                    />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Phone"
                        inputProps={{
                            pattern: "[0-9]*", // Regular expression to allow only digits
                        }}
                        value={telefono}
                        onChange={(e) => setTelefono(e.target.value)}
                    />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Cellphone"
                        inputProps={{
                            pattern: "[0-9]*", // Regular expression to allow only digits
                        }}
                        value={celular}
                        onChange={(e) => setCelular(e.target.value)}
                    />
                </Grid>

                <Grid item xs={6} sm={6}>
                    <TextField
                        required

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        fullWidth
                        label="Country"
                        value={pais}
                        onChange={(e) => setPais(e.target.value)}
                    />
                </Grid>

                <Grid item xs={6} sm={6}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="E-mail"
                        value={email}
                        type={"email"}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Grid>


                <Grid item xs={12}>
                    <Typography variant="h6">COMPANY INFORMATION</Typography>
                </Grid>

                <Grid item xs={6}>
                    <InputLabel >Company name</InputLabel>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={nombreEmpresa}
                        onChange={(e) => setNombreEmpresa(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputLabel >NIT</InputLabel>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={nit}
                        onChange={(e) => setNit(e.target.value)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Main Office Address"
                        value={direccionOficina}
                        onChange={(e) => setDireccionOficina(e.target.value)}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Country"
                        value={paisOficina}
                        onChange={(e) => setPaisOficina(e.target.value)}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        required
                        fullWidth
                        label="City"

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={ciudadOficina}
                        onChange={(e) => setCiudadOficina(e.target.value)}
                    />
                </Grid>

                <Grid item xs={2}>
                    <InputLabel > </InputLabel>
                    <TextField
                        required
                        label="Phone"
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={telefonoOficina}
                        onChange={(e) => setTelefonoOficina(e.target.value)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        required
                        fullWidth
                        label="Mail"
                        type={"email"}

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={correoOficina}
                        onChange={(e) => setCorreoOficina(e.target.value)}
                    />
                </Grid>


                <Grid item xs={3}>
                    <TextField

                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Address Branch or Agency"
                        value={direccionSucursal}
                        onChange={(e) => setDireccionSucursal(e.target.value)}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField

                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Country"
                        value={paisSucursal}
                        onChange={(e) => setPaisSucursal(e.target.value)}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField


                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        fullWidth
                        label="City"

                        value={ciudadSucursal}
                        onChange={(e) => setCiudadSucursal(e.target.value)}
                    />
                </Grid>

                <Grid item xs={2}>
                    <InputLabel > </InputLabel>
                    <TextField

                        label="Phone"
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        value={telefonoSucursal}
                        onChange={(e) => setTelefonoSucursal(e.target.value)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField

                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Mail"
                        type={"email"}
                        value={correoSucursal}
                        onChange={(e) => setCorreoSucursal(e.target.value)}
                    />
                </Grid>



                <Grid item xs={12} sm={3} style={{ padding: 8 }} >
                    <InputLabel >Date of incorporation of the company: </InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DatePicker value={fechainicialCompania}
                                onChange={(newValue) => { setfechainicialCompania(newValue); }} />
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                    <Typography style={{ textAlign: "left" }}> Do you have a risk management system?
                        BASC<Checkbox
                            required={certificadoBasc == true || certificadoIso == true || certificadoOea == true || otroCertificado != "" || certificadoNinguno == true ? false : true}
                            checked={certificadoBasc}

                            onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                            onInput={(e) => e.target.setCustomValidity("")}
                            onChange={(e) => {
                                setCertificadoBasc(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />, ISO 28001<Checkbox
                            checked={certificadoIso}
                            onChange={(e) => {
                                setCertificadoIso(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />, OEA<Checkbox
                            checked={certificadoOea}
                            onChange={(e) => {
                                setCertificadoOea(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />, <br></br>Others
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label=""
                                value={otroCertificado}
                                onChange={(e) => setOtroCertificado(e.target.value)}
                            />
                        </Grid>
                        , None<Checkbox
                            checked={certificadoNinguno}
                            onChange={(e) => {
                                setCertificadoNinguno(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />
                    </Typography>

                </Grid>


                <Grid item xs={12}>
                    <Typography style={{ textAlign: "left" }}> Do you have an Anti-Money Laundering and Terrorist Financing program? Which one?
                        Other
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label=""
                                value={otroLavadoDeActivos}
                                onChange={(e) => setOtroLavadoDeActivos(e.target.value)}
                            />
                        </Grid>
                        , Not applicable<Checkbox
                            checked={terrorismo}
                            onChange={(e) => {
                                setTerrorismo(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />
                    </Typography>

                </Grid>

                <Grid item xs={12}>
                    <Typography style={{ textAlign: "left" }}> Do you have a business ethics program?
                        <Checkbox
                            checked={eticaEmpresarial}
                            onChange={(e) => {
                                setEticaEmpresarial(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />
                    </Typography>

                </Grid>
                <Typography variant="h9" style={{ textAlign: "initial" }} >In accordance with current COLOMBIAN regulations, the following information is required to be sent by SAGRILAFT, therefore, please describe below the Partners or shareholders that own more than 5% of the company's shares:
                </Typography>



                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Identification</TableCell>
                                <TableCell>Name or corporate name</TableCell>
                                <TableCell>% participation</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableDataParticipacion.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    <TableCell>
                                        <TextField
                                            value={row.identificacion}
                                            onChange={(event) => handleCellChangeParticipacion(event, rowIndex, 'identificacion')}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={row.nombre}
                                            onChange={(event) => handleCellChangeParticipacion(event, rowIndex, 'nombre')}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={row.Participacion}
                                            onChange={(event) => handleCellChangeParticipacion(event, rowIndex, 'Participacion')}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Button variant="contained" color="primary" onClick={handleCopyRowParticiapacion}>
                        Add row
                    </Button>
                </TableContainer>


                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9" >1- Are you a public official or have you been a public official in the last two (2) years?
                        <Checkbox
                            checked={funcionarioPublico}
                            onChange={(e) => {
                                setFuncionarioPublico(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        />
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">2- Do you currently manage public resources or have you managed them during the last two (2) years?
                        <Checkbox
                            checked={administraRecursosPublicos}
                            onChange={(e) => {
                                setAdministraRecursosPublicos(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid><Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">3- Do you enjoy public recognition in any community?
                        <Checkbox
                            checked={reconocimientoPublico}
                            onChange={(e) => {
                                setReconocimientoPublico(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">4. ¿Cuenta con servicios o productos de empresas de origen local o que pertenezcan a mujeres y minorías?
                        <Checkbox
                            checked={servicioMujereMinoria}
                            onChange={(e) => {
                                setServicioMujereMinoria(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">5. ¿Cuenta con normas equitativas y ambientales? (Evaluaciones y auditorías ambientales en relación con el uso de energías renovables,
                        generación de desechos, emisiones de gases de efecto invernadero, entre otros)(Adjuntar soporte)
                        <Checkbox
                            checked={equitativasYAmbientales}
                            onChange={(e) => {
                                setEquitativasYAmbientales(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">6.¿Cuenta con medición de huella de carbono?(Adjuntar soporte)
                        <Checkbox
                            checked={huellaDeCarbono}
                            onChange={(e) => {
                                setHuellaDeCarbono(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">7.¿Cuenta con politicas que impulsen la reducción en el impacto y cuidado del medio ambiente?(Adjuntar soporte)
                        <Checkbox
                            checked={reducionImpactoAmbiente}
                            onChange={(e) => {
                                setReducionImpactoAmbiente(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">8. ¿Cuenta con certificaciones de sistemas de gestión?(Adjuntar soporte)
                        <Checkbox
                            checked={certificadoDeGestion}
                            onChange={(e) => {
                                setCertificadoDeGestion(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">All fields are required.
                        Note: If you have any special exemption please mention the rule.
                    </Typography>
                </Grid>
                <br></br>



                <Grid item xs={12}>
                    <Typography variant="h6">Activity in international operations</Typography>
                </Grid>
                <Grid item xs={4} style={{ textAlign: "initial" }}>
                    <Typography variant="h9">3- Do you carry out transactions in foreign currency?
                        <Checkbox
                            checked={checkRealizaTransaccionesMonedaExtra}
                            onChange={(e) => {
                                setCheckRealizaTransaccionesMonedaExtra(e.target.checked)
                            }}
                            inputProps={{
                                'aria-label': 'Checkbox A',
                            }}

                        /></Typography>
                </Grid>

                <Grid item xs={6} >
                    <Select
                        required={checkRealizaTransaccionesMonedaExtra}
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Tipo de Identificación"
                        // value={checkRealizaTransaccionesMonedaExtra == false ? "Ninguna" : tipoTransaccion}
                        value={tipoTransaccion}
                        onChange={(e) => setTipoTransaccion(e.target.value)}
                    >
                        {tipoTransaccionValue.map((tipo) => (
                            <MenuItem key={tipo} value={tipo}>
                                {tipo}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>


                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Product Type</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Country</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    <TableCell>
                                        <TextField
                                            disabled={!checkRealizaTransaccionesMonedaExtra}
                                            value={row.tipoProducto}
                                            onChange={(event) => handleCellChange(event, rowIndex, 'tipoProducto')}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            disabled={!checkRealizaTransaccionesMonedaExtra}
                                            type="number"
                                            value={row.monto}
                                            onChange={(event) => handleCellChange(event, rowIndex, 'monto')}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            disabled={!checkRealizaTransaccionesMonedaExtra}
                                            value={row.pais}
                                            onChange={(event) => handleCellChange(event, rowIndex, 'pais')}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Button variant="contained" color="primary" onClick={handleCopyRow}>
                        Add row
                    </Button>
                </TableContainer>


                <Grid item xs={12} sm={12}>
                    <TextField
                        fullWidth
                        label="otro"
                        value={otroTipo}
                        onChange={(e) => setOtroTipo(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">Declaration of origin of funds and authorization to consult in irrigation centers</Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption" >I expressly declare that. </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption" >1. The resources I have come from the following sources: (Detail occupation, trade, business, etc.) </Typography>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            required
                            fullWidth

                            onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                            onInput={(e) => e.target.setCustomValidity("")}
                            label="Detail"
                            value={Detalle}
                            onChange={(e) => setDetalle(e.target.value)}
                        />
                    </Grid>
                </Grid>


                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption" >2. My activity, profession or trade is lawful and I exercise it within the legal framework and the resources I possess do not come from illicit activities contemplated in the Colombian Criminal Code. </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption" >3.The information I have provided in this document is true and verifiable. </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption" >4. I irrevocably authorize the Company to request, consult, process or disclose the information contained in this form to any entity with which it has a current business relationship or which is duly authorized to manage or administer databases, including governmental entities."  </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption" >5. The resources derived from the development of this contract shall not be used for the financing of terrorism or any illegal activity.</Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">Authorization to consult and report information</Typography>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "justify" }}>
                    <Typography variant="caption">I, the undersigned acting on my own behalf and/or on behalf of the company {nombreEmpresa.toUpperCase()}  I authorize Tecnología Alimentaria S.A. S  BIC "TALSA", in an irrevocable, written, express, concrete, sufficient, voluntary and informed manner, so that all personal information, current and that generated in the future, as a result of the commercial and/or contractual relationships established with "TALSA", regarding my financial, credit, origin of funds, commercial and services behavior, that exists or may exist in databases, credit or information centers, national or foreign, especially that referring to the birth, execution and extinction of obligations, especially those related to the birth, execution and extinction of obligations, whether they are related to the creation, execution or extinction of obligations, I hereby authorize "TALSA", regardless of the nature of the contract that gave rise to them, to manage, capture, process, store, process and store my personal information, current and future, related to the birth, execution and termination of obligations that directly or indirectly have a monetary nature, regardless of the nature of the contract that gave rise to them; is administered, captured, processed, operated, verified, transmitted, transferred, used or put into circulation and consulted. I also authorize TALSA to deliver my information verbally, in writing or made available to third parties, to the administrative and judicial authorities that require it, to the control bodies and other disciplinary, fiscal or administrative investigation agencies when requested in the development of an investigation, to other operators when they have a similar purpose to that of the operator that delivers the data. Under oath I certify that the data provided by me are truthful, complete, accurate, updated and verifiable. Therefore, any error in the information provided by me shall be my sole and exclusive responsibility, which exonerates TALSA from its responsibility before the judicial and/or administrative authorities for the information provided herein..</Typography>
                </Grid>


                <Grid item xs={12} style={{ textAlign: "justify" }} >
                    <Typography variant="caption" ></Typography>
                    As proof of having read, understood and accepted the above, I declare that the information I have provided to TECNOLOGÍA ALIMENTARIA S.A.S. BIC is accurate in all its parts. <b> {currentDate.getDay()}</b>days of the month of<b> {currentDate.getMonth()}</b> of the year <b>{currentDate.getFullYear()}</b>   ,in the city of <b>{sucursalValue}</b>.
                </Grid>





                <Grid item xs={12}>
                    <Typography variant="h6">Required Documents</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor="RUT">Document certifying that the company is legally constituted in origin.</InputLabel>
                    <TextField
                        fullWidth
                        required

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        accept="application/pdf"
                        type="file"
                        onChange={handleRutChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor="Cámara de comercio">Copy of ID or passport of the legal representative</InputLabel>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        accept="application/pdf"
                        type="file"
                        onChange={handleCamaraComercioChange}
                    />
                </Grid>
                <Grid item xs={6} sm={6}>
                    <InputLabel htmlFor="Certificación bancaria">Bank certification</InputLabel>
                    <TextField
                        required

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        variant="outlined"
                        accept="application/pdf"
                        fullWidth
                        type="file"
                        onChange={handleCertificacionBancariaChange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputLabel htmlFor="Fotocopia de CC / ID del representante legal al 150%">Current certifications such as: BASC, ISO, OAS, others. </InputLabel>
                    <TextField
                        required

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        variant="outlined"
                        accept="application/pdf"
                        fullWidth
                        type="file"
                        onChange={handleCcIdRepresentanteChange}
                    />
                </Grid>


                <Grid item xs={12}>
                    <strong >Please send two commercial references </strong>
                    <InputLabel htmlFor="Fotocopia de CC / ID del representante legal al 150%">Commercial reference(1)</InputLabel>
                    <TextField
                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        variant="outlined"
                        accept="application/pdf"
                        fullWidth
                        type="file"
                        onChange={handlePolizaSeguroChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <InputLabel htmlFor="Fotocopia de CC / ID del representante legal al 150%">Commercial reference(2)</InputLabel>
                    <TextField
                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        variant="outlined"
                        accept="application/pdf"
                        fullWidth
                        type="file"
                        onChange={handlePolizaSeguroChange}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        required

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        fullWidth
                        label="Applicant name"
                        value={nombreSolicitante}
                        onChange={(e) => setNombreSolicitante(e.target.value)}
                    />
                </Grid><Grid item xs={4}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="Signature"
                        value={Firma}
                        onChange={(e) => setFirma(e.target.value)}
                    />
                </Grid><Grid item xs={4}>
                    <TextField
                        required
                        fullWidth

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        label="ID"
                        value={documentoFirma}
                        onChange={(e) => setDocumentoFirma(e.target.value)}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        required

                        onInvalid={(e) => e.target.setCustomValidity("Mandatory field")}
                        onInput={(e) => e.target.setCustomValidity("")}
                        fullWidth
                        label="Talsa employee name"
                        value={EmpleadoTalsa}
                        onChange={(e) => setEmpleadoTalsa(e.target.value)}
                    />
                </Grid>




                <Grid item xs={12} style={{ textAlign: "justify" }} >
                    <strong >Please sign, save and send </strong>
                    <br />
                    <div>
                        <br />

                        <SignatureCanvas
                            canvasProps={{
                                width: 550,
                                height: 150,
                                style: { "border": "1px solid #000000" }
                            }}
                            minWidth={1}
                            maxWidth={1}
                            penColor="black"
                            ref={sigPad}
                        />
                        <br /><Button onClick={() => {
                            sigPad.current.clear()
                            setFirmaFile(null)
                        }}
                            variant="contained"
                            component="label"
                            color="primary"
                            style={{ margin: "10px" }}>
                            Clear     </Button>
                        <Button variant="contained"
                            component="label"
                            color="primary"
                            style={{ margin: "10px" }} onClick={() => {
                                const canvas = sigPad.current.getCanvas();
                                const base64Data = canvas.toDataURL(); // Obtener el valor base64 de la imagen dibujada
                                setFirmaFile(base64Data)
                                swal("Thank you", "signed successfully", "success");
                            }}>Save</Button>
                    </div>
                </Grid>

                <Alert severity="warning">You must sign the form and then click the button to send information.</Alert>


                <Grid item xs={12}>
                    <LoadingButton
                        type="submit"
                        loading={loading}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="outlined">
                        Send to
                    </LoadingButton>
                </Grid>
            </Grid>
        </form >
    );
}

